import React from "react";
import { Grid } from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";
import type { VenueData } from "../../types/venues.types";

interface BasicInfoCardProps {
  venueData: VenueData;
  InfoCard: React.ComponentType<{
    title: string;
    icon: React.ReactNode;
    sx?: object;
    children: React.ReactNode;
  }>;
  InfoRow: React.ComponentType<{
    label: string;
    value: string;
  }>;
}

export const BasicInfoCard: React.FC<BasicInfoCardProps> = ({
  venueData,
  InfoCard,
  InfoRow,
}) => {
  const fullAddress = `${venueData.address_one}, ${venueData.address_two}, ${venueData.suburb}, ${venueData.city}, ${venueData.country}`;

  return (
    <InfoCard
      title="Basic Information"
      icon={<InfoIcon />}
      sx={{ height: "100%" }}
    >
      <Grid container spacing={2}>
        <InfoRow label="Venue Name" value={venueData.name || "N/A"} />
        <InfoRow label="Venue Type" value={venueData.venue_type || "N/A"} />
        <InfoRow label="Venue Capacity" value={venueData.capacity || "N/A"} />
        {venueData.layouts.map((layout, index) => (
          <InfoRow
            key={layout.id}
            label={`Layout ${index + 1} Capacity`}
            value={`${layout.layout_type} - ${layout.capacity}`}
          />
        ))}
        <InfoRow label="Address" value={fullAddress} />
        <InfoRow label="Time Zone" value={venueData.time_zone || "N/A"} />
        <InfoRow label="Additional Notes" value={venueData.notes || "N/A"} />
      </Grid>
    </InfoCard>
  );
};

export default BasicInfoCard;
